import { Navigation, Pagination, Autoplay } from 'swiper/modules';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Link } from "react-router-dom";

const BannersListar = ({banners}) => {
  return (
    <Swiper className="mainslider"
      // install Swiper modules
      modules={[Navigation, Pagination, Autoplay]}
      spaceBetween={50}
      slidesPerView={1}
      loop={true}
      navigation
      autoplay={{ delay: 4000 }} 
      pagination={{
        clickable: false
      }}
    >
      {banners.map((banner, index) => (
        <SwiperSlide key={index}>
          <div className="swiper-inner" style={{
                                              backgroundImage: `url(${banner.foto})`,
                                              width: '100%',
                                              height: '100%',
                                              backgroundSize: 'cover',
                                              backgroundPosition: 'center',
                                              display: 'block'
                                            }}>
            <div className="sw-caption">
                <div className="container">
                    <div className="row gx-5 align-items-center">
                        <div className="col-lg-8 mb-sm-30">
                            <h1 className="slider-title text-uppercase mb-1"></h1>
                        </div>
                        <div className="col-lg-6">
                            <p className="slider-text"></p>
                            <div className="sw-price wp">
                                <div className="d-starting">
                                </div>
                                <div className="d-price">
                                    <span className="d-cur"></span>
                                    <span className="d-val"></span>
                                    <span className="d-period"></span>
                                </div>
                            </div>
                            <div className="spacer-10"></div>
                            <Link className="btn-main mb10" to={banner.linkBanner} target="_blank">{banner.textoBanner}</Link>
                        </div>
                    </div>
                </div>
            </div>
            <div className="sw-overlay"></div>
        </div> 
      </SwiperSlide>
      ))}
    </Swiper>
  );
};
export default BannersListar;